/* ------------------------------------------------------------
 * グローバルナビ
 * ---------------------------------------------------------- */

(function (factory) {
  if (typeof jQuery === 'undefined') {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        if (typeof jQuery !== 'undefined')
          factory(jQuery);
      }
    );
  } else {
    factory(jQuery);
  }
})(function ($) {
  'use strict';

  const BP_PC = 1023.5;
  const isSP = () =>
    window.matchMedia(`(max-width:${BP_PC}px)`)
      .matches;

  // 必須DOM取得（存在しないページでは早期return）
  const $nav = $('.global_nav');
  if ($nav.length === 0) return;

  // SP用ハンバーガー
  const $btn = $('#sp_menu_button .menu-trigger');

  // pulldownコンテナ（PC: absolute, SP: static）
  const $wrap = $nav.find(
    '.global_nav__pulldown'
  );

  // 個別パネル
  const $inners = $wrap.find(
    '.global_nav__pulldown__inner'
  );

  // PCのメニュー行
  const $menu = $nav.find('.global_nav__menu');
  // PCの各項目
  const $items = $menu.find(
    '> .global_nav__menu__item'
  );

  if ($wrap.length === 0 || $inners.length === 0)
    return; // パネルが無いページは終了

  // 共通: SPモードでコンテナ/各パネルを閉じる（＋背面スクロール解除）
  const resetPulldownAll = () => {
    // コンテナを閉
    $wrap
      .stop(true, true)
      .hide()
      .removeClass('is-open');
    // 各パネルの開閉状態をリセット
    $inners
      .removeClass('is-active')
      .each(function () {
        $(this)
          .children('.pulldown_menu')
          .stop(true, true)
          .hide();
      });
    // 背面スクロール解除（SPメニューを閉じたら戻す）
    document.body.style.overflow = '';
  };

  //  SPメニュー（<=1023.5px）
  const bindSP = () => {
    // 競合するPCイベントを除去
    $btn && $btn.off('.sp');
    $wrap.off('.sp');
    $items.off('.pc');
    $wrap.off('.pc');
    $(document).off('.pc');

    // 初期状態
    if ($btn && $btn.length)
      $btn.attr('aria-expanded', 'false');
    resetPulldownAll();

    // ハンバーガーで全体を開閉
    if ($btn && $btn.length) {
      $btn.on('click.sp', function (e) {
        if (!isSP()) return; // PCでは無効
        e.preventDefault();

        const open =
          $(this).attr('aria-expanded') !==
          'true';
        $(this).attr(
          'aria-expanded',
          String(open)
        );

        if (open) {
          // 開く：下方向にスライド＋背面スクロール禁止
          $wrap
            .stop(true, true)
            .slideDown(300)
            .addClass('is-open');
          document.body.style.overflow = 'hidden';
        } else {
          // 閉じる：上方向にスライド＋状態リセット（背面スクロール解除含む）
          $wrap
            .stop(true, true)
            .slideUp(300, () =>
              resetPulldownAll()
            );
        }
      });
    }

    // pulldown_titleリンク遷移&pulldown_menu開閉
    $wrap
      .off('click.spTitle')
      .on(
        'click.spTitle',
        '.pulldown_title > a',
        function (e) {
          if (!isSP()) return;

          const $a = $(this);
          const $inner = $a.closest(
            '.global_nav__pulldown__inner'
          );
          if (!$inner.length) return;

          const $list = $inner.children(
            '.pulldown_menu'
          ); // pulldownなし（05～07）は常に遷移
          if (!$list.length) return;

          // pulldownあり（01～04）はどこをクリックしてもアコーディオン開閉
          e.preventDefault();
          e.stopPropagation();

          // トグル開閉
          const willOpen = !$list.is(':visible');
          $list.stop(true, true);
          if (willOpen) {
            $list
              .css('display', 'none')
              .slideDown(240, () => {
                $list.css('display', 'block');
                $inner.addClass('is-active');
              });
          } else {
            $list.slideUp(220, () => {
              $list.css('display', 'none');
              $inner.removeClass('is-active');
            });
          }
        }
      );
  };

  // PCメニュー（>=1024px）
  const bindPC = () => {
    // 競合するSPイベントを除去
    $btn.off('.sp');
    $wrap.off('.sp');

    // 初期：全パネルを閉
    const $allPanels = $inners;
    $allPanels
      .stop(true, true)
      .hide()
      .removeClass('is-active');

    // 閉じ制御（チラつき防止の遅延付き）
    let closeTimer = null;
    const hideAllNow = () => {
      $allPanels
        .stop(true, true)
        .hide()
        .removeClass('is-active');
    };
    const scheduleClose = () => {
      clearTimeout(closeTimer);
      closeTimer = setTimeout(hideAllNow, 120);
    };
    const cancelClose = () => {
      clearTimeout(closeTimer);
    };

    // メニュー各項目を対応パネルに紐づけ
    $items.each(function () {
      const $li = $(this);
      const cls = ($li.attr('class') || '')
        .split(/\s+/)
        .find(
          c =>
            c.indexOf(
              'global_nav__menu__item--menu'
            ) === 0
        );
      if (!cls) return;
      const num = cls.replace(
        'global_nav__menu__item--menu',
        ''
      );

      // pulldownなし:何もしない
      if (['05', '06', '07'].includes(num)) {
        $li.off('.pc');
        return;
      }

      const $panel = $wrap.find(
        `.global_nav__pulldown__inner${num}`
      );
      if (!$panel.length) return;

      // 項目側：hover/focusで開き、外したら閉じ遅延
      $li
        .off('.pc')
        .on('mouseenter.pc focusin.pc', () => {
          cancelClose();
          // 他パネルは即hide
          $allPanels
            .not($panel)
            .stop(true, true)
            .hide()
            .removeClass('is-active');
          // 対象パネルのみ開（開時のみslide）
          $panel
            .stop(true, true)
            .slideDown(200)
            .addClass('is-active');
        })
        .on(
          'mouseleave.pc focusout.pc',
          scheduleClose
        );

      // パネル側でも同様に監視（パネル上では閉じ遅延をキャンセル）
      $panel
        .off('.pc')
        .on(
          'mouseenter.pc focusin.pc',
          cancelClose
        )
        .on(
          'mouseleave.pc focusout.pc',
          scheduleClose
        );
    });

    // コンテナ全体でも閉じ遅延
    $wrap
      .off('.pc')
      .on('mouseenter.pc focusin.pc', cancelClose)
      .on(
        'mouseleave.pc focusout.pc',
        scheduleClose
      );

    // ナビ外へフォーカスが移動したら即閉
    $(document)
      .off('.pc')
      .on('focusin.pc', ev => {
        if (!$nav[0].contains(ev.target))
          hideAllNow();
      });

    // 念のため：PCに切り替わった際は背面スクロールを解除
    document.body.style.overflow = '';
  };

  // 初期適用＆リサイズでの切り替え
  const apply = () =>
    isSP() ? bindSP() : bindPC();
  apply();
  $(window).on('resize', apply);
});

/* ------------------------------------------------------------
 * 現在ページのハイライト表示
 * ---------------------------------------------------------- */
(function (factory) {
  if (typeof jQuery === 'undefined') {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        if (typeof jQuery !== 'undefined')
          factory(jQuery);
      }
    );
  } else {
    factory(jQuery);
  }
})(function ($) {
  'use strict';

  // 現在のページパスを取得
  const currentPath = window.location.pathname;

  const matchedItems = []; // マッチした項目を記録

  // 各メニュー項目を走査
  $('.global_nav__menu__item').each(function (
    index
  ) {
    const $menuItem = $(this);

    // このメニュー項目のクラスを確認
    const menuClass = $menuItem.attr('class');

    // クラス名から番号を抽出
    const menuNum = menuClass.match(/menu(\d+)/);

    if (!menuNum) return;

    const num = menuNum[1];

    // 対応するpulldown_innerを検索
    const selector = `.global_nav__pulldown__inner${num}`;
    const $pulldownInner = $(selector);

    if ($pulldownInner.length === 0) return;

    let matchType = null; // 'exact', 'partial', null

    // 1. pulldown_menu内のリンクをチェック（完全一致のみ）
    const $pulldownMenu = $pulldownInner.find(
      '.pulldown_menu'
    );

    if ($pulldownMenu.length > 0) {
      $pulldownMenu
        .find('.pulldown_menu__item a')
        .each(function () {
          const linkHref = $(this).attr('href');

          if (!linkHref) return;

          const normalizedCurrent =
            currentPath.replace(/\/$/, '');
          const normalizedLink = linkHref.replace(
            /\/$/,
            ''
          );

          if (
            normalizedCurrent === normalizedLink
          ) {
            matchType = 'exact';
            return false; // ループを抜ける
          }
        });
    }

    // 2. pulldown_titleのリンクをチェック（完全一致）
    if (!matchType) {
      const $pulldownTitle = $pulldownInner.find(
        '.pulldown_title a'
      );
      const titleLinkHref =
        $pulldownTitle.attr('href');

      if (titleLinkHref) {
        const normalizedCurrent =
          currentPath.replace(/\/$/, '');
        const normalizedTitleLink =
          titleLinkHref.replace(/\/$/, '');

        if (
          normalizedCurrent ===
          normalizedTitleLink
        ) {
          matchType = 'exact';
        }
      }
    }

    // 3. 前方一致チェック（pulldown_titleのみ、pulldown_menuがない場合）
    if (
      !matchType &&
      $pulldownMenu.length === 0
    ) {
      const $pulldownTitle = $pulldownInner.find(
        '.pulldown_title a'
      );
      const titleLinkHref =
        $pulldownTitle.attr('href');

      if (titleLinkHref) {
        const normalizedCurrent =
          currentPath.replace(/\/$/, '');
        const normalizedTitleLink =
          titleLinkHref.replace(/\/$/, '');

        if (
          normalizedCurrent.startsWith(
            normalizedTitleLink
          )
        ) {
          matchType = 'partial';
        }
      }
    }

    // マッチした項目を記録
    if (matchType) {
      matchedItems.push({
        $menuItem: $menuItem,
        num: num,
        matchType: matchType
      });
    }
  });

  // 完全一致が存在する場合は完全一致のみ、なければ前方一致を適用
  const hasExactMatch = matchedItems.some(
    item => item.matchType === 'exact'
  );

  matchedItems.forEach(item => {
    // 完全一致がある場合は完全一致のみ適用
    if (
      hasExactMatch &&
      item.matchType === 'exact'
    ) {
      item.$menuItem.addClass('is-current');
    }
    // 完全一致がない場合は前方一致も適用
    else if (
      !hasExactMatch &&
      item.matchType === 'partial'
    ) {
      item.$menuItem.addClass('is-current');
    }
  });
});

/* ------------------------------------------------------------
 * ページTOP 戻るボタン
 * ---------------------------------------------------------- */
(function () {
  'use strict';

  function initPageTop() {
    document
      .querySelectorAll('.pagetop')
      .forEach(function (el) {
        el.addEventListener(
          'click',
          function (e) {
            e.preventDefault();
            window.scrollTo({
              top: 0,
              behavior: 'smooth'
            });
          }
        );
      });
  }

  // DOMContentLoaded後に実行
  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initPageTop
    );
  } else {
    // DOMが既に読み込まれている場合はすぐに実行
    initPageTop();
  }
})();

/* ------------------------------------------------------------
 * 1023.5pxを跨いだ時のみ自動リロード
 * ---------------------------------------------------------- */
(function () {
  const BP_PC = 1023.5;
  const mq = window.matchMedia(
    `(max-width:${BP_PC}px)`
  );
  const onChange = function () {
    if ('scrollRestoration' in history) {
      try {
        history.scrollRestoration = 'manual';
      } catch (err) {
        // no-op: 一部環境で例外になるため無視
      }
    }
    location.reload();
  };
  if (mq.addEventListener) {
    mq.addEventListener('change', onChange);
  } else if (mq.addListener) {
    mq.addListener(onChange);
  }
})();
